export const socialLinks = [
	// {
	// 	id: 1,
	// 	name: 'Website',
	// 	icon: 'globe',
	// 	url: 'https://www.stoman.me/',
	// },
	{
		id: 1,
		name: 'GitHub',
		icon: 'github',
		url: 'https://github.com/imranctg16',
	},
	{
		id: 2,
		name: 'LinkedIn',
		icon: 'linkedin',
		url: 'www.linkedin.com/in/mohammad-imran-hossain-783803135/',
	},
	
];
